import React, { Component, PropTypes } from 'react';
import './input.scss';

export default class Input extends Component {
    static propTypes = {
        centeredBlock: PropTypes.bool,
        title: PropTypes.string,
    }

    render() {
        const {centeredBlock, ...otherProps} = this.props;

        return (
            <div className={`input-wrapper ${centeredBlock ? 'input-wrapper-centered-block' : ''}`}>
                <If condition={this.props.title}>
                    <div className="input-title">{this.props.title}</div>
                </If>
                <input {...otherProps} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/views/input/Input.js